import React from "react";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import Button from "@material-ui/core/Button";
import validate from "./validate";
import ParticipantForm from "./form";
import { makeStyles } from "@material-ui/styles";

const inititial = {
  firstName: "",
  lastName: "",
  civicRegistrationNumber: "",
};

const useStyles = makeStyles({
  container: {},
  actionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: "16px",
    "& button": {
      marginLeft: "8px",
    },
  },
});

const Form = React.memo(function Form(props) {
  const { handleSubmit, id, close } = props;
  const classes = useStyles();
  const { language, config } = useSelector((state) => ({
    language: state.language,
    config: state.config,
  }));
  const { requiredFields } = config.fieldInfo.registerParticipant;
  return (
    <Formik
      initialValues={{ ...inititial, id, participantIsForRegistration: true }}
      onSubmit={(values, actions) =>
        console.log(values) || handleSubmit(values, actions)
      }
      validate={(values) => validate(values, requiredFields, language)}
      render={(props) => (
        <div className={classes.container}>
          <ParticipantForm />
          <div className={classes.actionContainer}>
            <Button color="secondary" type="button" onClick={close}>
              {language.abort}
            </Button>
            <Button
              disabled={!props.isValid}
              onClick={props.submitForm}
              color="primary"
              type="submit"
            >
              {language.book} {props?.values?.firstName}
            </Button>
          </div>
        </div>
      )}
    />
  );
});

export default Form;
